var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 26 26",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M6 2h6m2 0h6M6 3h6m2 0h6M6 4h2m4 0h2m4 0h2M6 5h2m4 0h2m4 0h2M2 6h6m10 0h6M2 7h6m10 0h6M2 8h2m18 0h2M2 9h2m18 0h2M2 10h2m6 0h6m6 0h2M2 11h2m6 0h6m6 0h2M4 12h2m4 0h2m2 0h2m4 0h2M4 13h2m4 0h2m2 0h2m4 0h2M2 14h2m6 0h6m6 0h2M2 15h2m6 0h6m6 0h2M2 16h2m18 0h2M2 17h2m18 0h2M2 18h6m10 0h6M2 19h6m10 0h6M6 20h2m4 0h2m4 0h2M6 21h2m4 0h2m4 0h2M6 22h6m2 0h6M6 23h6m2 0h6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#695c26",
    d: "M8 4h4m2 0h4M8 5h4m2 0h4M8 6h6M8 7h6M4 8h6m8 0h2M4 9h6m8 0h2M4 10h4m-4 1h4m-2 1h2m-2 1h2m-4 1h2m-2 1h2m-2 1h2m-2 1h2m2 1h2m-2 1h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#404040",
    d: "M14 6h2m-2 1h2m-6 1h8m-8 1h8M8 10h2m6 0h4M8 11h2m6 0h4M8 12h2m6 0h2M8 13h2m6 0h2M6 14h4m6 0h2M6 15h4m6 0h2M8 16h8m-8 1h8m-6 1h2m-2 1h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#292b42",
    d: "M16 6h2m-2 1h2m2 1h2m-2 1h2m-2 1h2m-2 1h2m-4 1h2m-2 1h2m-2 1h4m-4 1h4M6 16h2m8 0h6M6 17h2m8 0h6m-10 1h6m-6 1h6M8 20h4m2 0h4M8 21h4m2 0h4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.4732072479dd9793eb496f8be7d749a8.svg";
export { ForwardRef as ReactComponent };